<template>
  <div id="app">
    <div v-if="filters && filters.categories" class="spacing-l">
      <Categories
        :update-filter="updateFilter"
        :categories="filters.categories"
        :active-category="appliedfilters.category"
      />
    </div>
    <div v-if="filters && filters.tags" class="l-box l-box--wide spacing-l">
      <Tags
        :update-filter="updateFilter"
        :tags="filters.tags[appliedfilters.category]"
        :active-tag="appliedfilters.tag"
      />
    </div>
    <div class="l-box l-box--wide">
      <transition-group name="srv-fade" tag="div" class="sr-contents-items js-loadOnScroll">
        <Item v-for="item in displayItems" :item-value="item" :key="item.id" />
      </transition-group>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import matches from 'lodash/matches';
import merge from 'lodash/merge';
import omitBy from 'lodash/omitBy';
import take from 'lodash/take';
import throttle from 'lodash/throttle';

import Categories from './components/categories';
import Tags from './components/tags';
import Item from './components/item';

const ITEMS_PER_PAGE = 8;
const scrollThreshold = window.innerHeight / 3;

export default {
  name: 'app',
  components: {
    Categories,
    Tags,
    Item
  },
  data() {
    return {
      items: [],
      pageIndex: 1,
      filters: {},
      appliedfilters: {}
    };
  },
  methods: {
    updatePageIndex(value) {
      Vue.set(this, 'pageIndex', value);
      Vue.set(this, 'pageIndex', value);
    },
    updateFilter(value) {
      const { appliedfilters } = this;

      this.updatePageIndex(1);
      Vue.set(this, 'appliedfilters', omitBy(merge(appliedfilters, value), isEmpty));
    },
    handleScroll: throttle(function() {
      if (this.filteredItems.length / ITEMS_PER_PAGE <= this.pageIndex) {
        return;
      }

      const target = document.getElementsByClassName('js-loadOnScroll')[0].getBoundingClientRect();

      const scrollYValue = window.scrollY || window.pageYOffset;
      if (scrollYValue + window.innerHeight + scrollThreshold >=
          scrollYValue + target.top + target.height) {
        this.updatePageIndex(this.pageIndex + 1);
      }
    }, 250)
  },
  computed: {
    filteredItems() {
      return filter(this.items, matches(this.appliedfilters));
    },
    displayItems() {
      return take(this.filteredItems, ITEMS_PER_PAGE * this.pageIndex);
    }
  },
  created() {
    const self = this;

    fetch(`${location.href.replace(/[^/]*$/, '')}data.json`, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    }).then(response => response.json())
    .then(json => {
      Vue.set(self, 'items', json.items);

      if (json.filters) {
        Vue.set(self, 'filters', json.filters);
        self.updateFilter({ category: self.filters.categories[0].value });
      }
    }).catch(error => {
      console.log(error);
    });

    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.srv-fade-enter-active,
.srv-fade-leave-active {
  transition: opacity 0.5s;
}

.srv-fade-enter,
.srv-fade-leave {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/app.vue